import React, { useState, useRef, Fragment, useEffect } from "react";
import DirectoryLayout from "../DirectoryLayout";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { Table, TableHead, TableBody } from "component/common/Table/index";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import ErrorMessage from "component/common/ErrroMessage/index";
import TextInput from "component/common/TextInput";
import Pagination from "component/common/Pagination";
import TextField from "component/common/TextField";
import { Toast } from "utils/toast";
import { useForm } from "react-hook-form";
import Loader from "component/common/Loader";
import DeleteConfirmation from "component/common/DeleteConfirmation";
import {
  getAllInfluencer,
  deleteInfluencer,
  updateInfluencer,
} from "service/Directory";
import eye from "assets/images/eye.svg";
import edit from "assets/images/edit.svg";
import dustbin from "assets/images/dustbin.svg";

import styles from "./Influencer.module.scss";
import { getRoleAction } from "utils/helper";

const Influencer = () => {
  const location = useLocation();

  const history = useHistory();

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  const { isOperationAvailable } = getRoleAction("Directory");

  const head = ["Influencer Name", "Instagram Handle", "No of Followers", ""];

  let [influencer, setInfluencer] = useState();

  let [activeIndex, setActiveIndex] = useState(null);

  let [confirmation, setConfirmation] = useState(false);

  let [id, setId] = useState(null);

  let [totalPages, setTotalPages] = useState();

  let [temp, setTemp] = useState(null);

  const page = new URLSearchParams(location.search).get("page");

  const search = new URLSearchParams(location.search).get("search");

  useEffect(() => {
    getInfluencer();
  }, [page, search]);

  const getInfluencer = async () => {
    try {
      let response = await getAllInfluencer({
        page: page != null ? page : 1,
        search: search != null ? search : null,
      });
      if (response.status == 200) {
        setInfluencer(response.data.data.data);
        setTotalPages(response.data.data.pageMeta.totalPages);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const onDelete = async () => {
    try {
      let response = await deleteInfluencer(id);
      if (response.status == 200) {
        toggleConfirmation();
        getInfluencer();
        Toast({
          type: "success",
          message: "Influencer has been deleted successfully",
        });
        setId(null);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const onSubmit = async (data) => {
    let body = {
      influencerId: temp?._id,
      phoneNumber: data.phoneNumber,
      address: data.address,
      notes: data.notes,
    };
    try {
      let response = await updateInfluencer(body);
      if (response.status == 200) {
        toggleAccordian(null);
        setTemp(null);
        getInfluencer();
        Toast({
          type: "success",
          message: "Influencer details has been updated successfully",
        });
        reset();
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggleAccordian = (index) => {
    setActiveIndex(index);
  };

  const toggleConfirmation = () => {
    setConfirmation(!confirmation);
  };

  const showConfirmation = (id) => {
    setId(id);
    toggleConfirmation();
  };

  const handlePageChange = async (event) => {
    if (search != null) {
      await history.push({
        search: `?search=${search}&page=${event}`,
      });
    } else {
      await history.push({ search: `?page=${event}` });
    }
    setInfluencer(null);
  };

  const onEdit = (index, data) => {
    toggleAccordian(index);
    setTemp(data);
    reset({
      phoneNumber: data.phoneNumber,
      address: data.address,
      notes: data.notes,
    });
  };

  if (influencer == null) return <Loader />;

  return (
    <>
      <DirectoryLayout page="influencer" refresh={getInfluencer} />
      <Table>
        <TableHead className={styles.influencer_head} head={head} />
        <TableBody>
          {influencer.length != 0 ? (
            influencer.map((list, index) => {
              return (
                <Fragment key={index}>
                  <tr className={styles.influencer_body}>
                    <td>{list.influencerName}</td>
                    <td>{list.instagramHandle}</td>
                    <td>{list.numberOfFollowers}</td>
                    <td>
                      <UncontrolledDropdown>
                        <DropdownToggle tag="span" data-toggle="dropdown">
                          <i className="icon-dots"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          {isOperationAvailable("View") && (
                            <DropdownItem
                              onClick={() => {
                                toggleAccordian(index);
                                setTemp(null);
                              }}
                            >
                              <div className="dropdown-items">
                                <img src={eye} />
                                <span>View</span>
                              </div>
                            </DropdownItem>
                          )}
                          {isOperationAvailable("Edit") && (
                            <DropdownItem onClick={() => onEdit(index, list)}>
                              <div className="dropdown-items">
                                <img src={edit} />
                                <span>Edit</span>
                              </div>
                            </DropdownItem>
                          )}
                          {isOperationAvailable("Delete") && (
                            <DropdownItem
                              onClick={() => showConfirmation(list._id)}
                            >
                              <div className="dropdown-items">
                                <img src={dustbin} />
                                <span>Delete</span>
                              </div>
                            </DropdownItem>
                          )}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                  <tr
                    style={{
                      border:
                        activeIndex === index ? "1px solid #C4C4C4" : "none",
                    }}
                  >
                    <td colSpan="4" style={{ padding: "0px" }}>
                      <div
                        className="table-accordian"
                        style={{
                          maxHeight: activeIndex === index ? "500px" : "0px",
                        }}
                      >
                        <div className="row" style={{ padding: "20px 60px" }}>
                          <div className="col-md-3">
                            <div style={{ marginBottom: "20px" }}>
                              {temp !== null && temp._id == list._id ? (
                                <>
                                  <TextInput
                                    label="Contact Number"
                                    value={list.phoneNumber}
                                    register={register("phoneNumber", {
                                      required: true,
                                      pattern: /^[0-9]{10}$/,
                                    })}
                                    error={errors.phoneNumber}
                                  />
                                  <ErrorMessage
                                    error={errors.phoneNumber}
                                    message={{
                                      required: "Please enter phone number",
                                      pattern:
                                        "Phone number contain 10 numbers only",
                                    }}
                                  />
                                </>
                              ) : (
                                <TextInput
                                  label="Contact Number"
                                  value={list.phoneNumber}
                                  disabled={true}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div style={{ marginBottom: "20px" }}>
                              {temp !== null && temp._id == list._id ? (
                                <>
                                  <TextField
                                    label="Address"
                                    register={register("address", {
                                      required: true,
                                      minLength: 3,
                                    })}
                                    value={list.address}
                                    error={errors.address}
                                  />
                                  <ErrorMessage
                                    error={errors.address}
                                    message={{
                                      required: "Please enter address",
                                      minLength:
                                        "Address contain atleast 3 characters",
                                    }}
                                  />
                                </>
                              ) : (
                                <TextField
                                  label="Address"
                                  value={list.address}
                                  disabled={true}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div style={{ marginBottom: "20px" }}>
                              {temp !== null && temp._id == list._id ? (
                                <>
                                  <TextField
                                    label="Notes"
                                    register={register("notes", {
                                      required: true,
                                    })}
                                    error={errors.notes}
                                    value={list.notes}
                                  />
                                  <ErrorMessage
                                    error={errors.notes}
                                    message={{
                                      required: "Please enter notes",
                                    }}
                                  />
                                </>
                              ) : (
                                <TextField
                                  label="Notes"
                                  register={register("notes", {
                                    required: true,
                                  })}
                                  error={errors.notes}
                                  value={list.notes}
                                  disabled={true}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-md-12">
                            {temp == null ? (
                              <div className={styles.infuencer_edit}>
                                <button
                                  className={styles.close}
                                  onClick={() => {
                                    toggleAccordian();
                                    setTemp(null);
                                  }}
                                >
                                  CLOSE
                                </button>
                                <button
                                  className={styles.edit}
                                  onClick={() => {
                                    toggleAccordian(index);
                                    setTemp(list);
                                    reset({
                                      address: list.address,
                                      notes: list.notes,
                                      phoneNumber: list.phoneNumber,
                                    });
                                  }}
                                >
                                  EDIT
                                </button>
                              </div>
                            ) : (
                              <SaveCancelBtn
                                onCancel={() => {
                                  toggleAccordian();
                                  setTemp(null);
                                }}
                                margin={10}
                                onSave={handleSubmit(onSubmit)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="4" className="no-record">
                No Records Found
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={page != null ? page : 1}
          onPageChange={handlePageChange}
        />
      )}
      <DeleteConfirmation
        message="Are you sure to delete this influencer?"
        isOpen={confirmation}
        toggle={toggleConfirmation}
        onSubmit={onDelete}
      />
    </>
  );
};

export default Influencer;
